<script>
import { onMounted, ref, toRef } from "vue";

export default {
  name: "NotarialCasesComponent",
  props: {
    notarialCases: {
      type: Array,
      required: true
    },
    setNotary: {
      type: Function,
      required: true
    },
    setNotarialCaseNumber: {
      type: Function,
      required: true
    },
    toLocalSearchNotaryAction: {
      type: Function,
      required: true
    },
    testator: {
      type: Object,
      required: true
    },
    setNotarialCaseDateDeath: {
      type: Function,
      required: true
    }
  },
  setup(props) {

    const currentCaseIndex = ref(0);
    const notarialCases = toRef(props, 'notarialCases');
    const setNotary = props.setNotary;
    const setNotarialCaseNumber = props.setNotarialCaseNumber;
    const setNotarialCaseDateDeath = props.setNotarialCaseDateDeath;

    const handleSelect = (i) => {
      currentCaseIndex.value = i;
      const currentCase = notarialCases.value[currentCaseIndex.value];
      setNotary({
        name: currentCase.notaryName,
        region: currentCase.notaryRegion
      });
      setNotarialCaseNumber(currentCase.caseNumber);
      setNotarialCaseDateDeath(currentCase.dateDeathUnix);
    };

    onMounted(() => {
      handleSelect(currentCaseIndex.value);
    });

    return {
      currentCaseIndex,
      handleSelect
    }
  }
}
</script>

<template>
  <div class="notary-list">
    <div class="form-group">
      <label>Найдены наследственные дела у нотариуса:</label>
      <div class="notary-items">
        <div v-for="(caseItem, index) in notarialCases" :key="index">
          <input
            type="radio"
            :value="index"
            :checked="currentCaseIndex === index"
            @click="handleSelect(index)"
          />
          <span>{{ caseItem.notaryName }} ({{ caseItem.notaryRegion }}), №{{ caseItem.caseNumber }}, Дата смерти: {{ caseItem.dateDeath }}</span>
        </div>
      </div>
      <div class="info-text">
        <p v-if="notarialCases.length>1">Выберите нужное дело о наследстве.</p>
        <p>Если данные корректны, то отправляйте Заказ на обработку.</p>
        <p>Если нет, то укажите нужного нотариуса вручную по его ФИО</p>
        <p><a href="#" @click="toLocalSearchNotaryAction">Выбрать нотариуса вручную</a></p>
      </div>
    </div>
  </div>
</template>

<style scoped>

.notary-items input {
  margin-right: 5px;
}

.form-group {
  margin-bottom: 0;
}

.info-text {
  margin-top: 10px;
}

.info-text>p {
  margin-bottom: 5px;
}

.info-text>p:last-child {
  margin-bottom: 0;
}

</style>
